import React, { useState, useContext } from "react"
import "./newFolder.scss"
import { Mutation } from "react-apollo"
import gql from "graphql-tag"
import Button from "../../../../components/Button"
import TextField from "../../../../components/TextField"
import { getViewerFolders } from "../../queries"
import { MESSAGE_TYPE } from "../FavoriteFile/const"
import { ModalMessage } from "../../../../components/Modal"
import AppContext from "../../../../shared/AppContext"

const CREATE_FOLDER = gql`
  mutation CreateNewFavoritesFolder($name: String!) {
    createFavoritesFolder(name: $name) {
      id
      response {
        payload
        message
      }
    }
  }
`

const NewFolder = (props) => {
  const [folderName, setFolderName] = useState("")
  const [message, setMessage] = useState({ type: "", text: "" })
  const { trackEvent } = useContext(AppContext)

  const handleCancel = () => {
    props.isModalOpen(false)
  }

  const handleCreate = (mutate) => {
    if (!folderName.trim()) {
      return setMessage({
        type: MESSAGE_TYPE.REQUIRED,
        text: "Name is required",
      })
    }

    mutate({
      variables: {
        name: folderName.trim(),
      },
      refetchQueries: [{ query: getViewerFolders }],
    })
      .then(({ data }) => {
        const { createFavoritesFolder } = data
        setMessage({
          type: createFavoritesFolder.response.payload,
          text: createFavoritesFolder.response.message,
        })
        if (
          createFavoritesFolder.response &&
          createFavoritesFolder.response.payload === MESSAGE_TYPE.SUCCESS
        ) {
          trackEvent("Created New Folder", {
            location: props.trackingLocation,
            folderName: folderName,
          })
        }
      })
      .catch((err) => {
        setMessage({
          type: MESSAGE_TYPE.SAVE_ERROR,
          text:
            "Oh no! Something went wrong. Please go to https://app.etr.ai/help to get support",
        })
        console.log("Unknown error while creating a folder: ", err)
      })
  }

  const renderError = () => {
    return (
      <div className="new-folder-input-error">
        <span>{message.text}</span>
      </div>
    )
  }

  if (message.type == MESSAGE_TYPE.SUCCESS) {
    return (
      <ModalMessage
        messageType={MESSAGE_TYPE.SUCCESS}
        closeModal={handleCancel}
        text={
          <>
            A new folder named <strong> {folderName} </strong>has been
            successfully created.
          </>
        }
      />
    )
  }

  return (
    <Mutation mutation={CREATE_FOLDER}>
      {(mutate) => (
        <div className="new-folder-container">
          <div className="new-folder-inputs-container">
            <div className="folder-input">
              <div className="new-folder-input-label">
                <span>Folder Name</span>
              </div>
              {(message.type == MESSAGE_TYPE.REQUIRED ||
                message.type == MESSAGE_TYPE.ALREADY_EXISTS) &&
                renderError()}
              <TextField
                value={folderName}
                fullWidth={true}
                placeholder="Vendor/Sector Name"
                errors={message.type == MESSAGE_TYPE.REQUIRED}
                errorOptions={{
                  outline: true,
                  showMessage: false,
                  hasError: true,
                }}
                onChange={(e) => {
                  setFolderName(e.target.value)
                }}
              />
            </div>
          </div>
          {message.type === MESSAGE_TYPE.SAVE_ERROR && (
            <ModalMessage
              messageType={MESSAGE_TYPE.SAVE_ERROR}
              text={message.text}
              style={{ textAlign: "right" }}
            />
          )}
          <div className="new-folder-buttons-container">
            <Button
              action={handleCancel}
              classes={["new-folder-cancel-button"]}
              text={"Cancel"}
            />
            <Button
              action={() => handleCreate(mutate)}
              classes={["new-folder-create-button"]}
              text={"Create"}
            />
          </div>
        </div>
      )}
    </Mutation>
  )
}

export default NewFolder
